function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from '../components/includes/Common';
import { Container, Col, Row, ControlLabel } from 'react-bootstrap';
import { message, Skeleton, Descriptions, Tabs, Space, Tag, Button, Divider, Modal } from 'antd';
import ChangePassword from "../components/forms/ChangePassword";
import { PersonCircle, PersonLinesFill, PersonFillLock, HospitalFill, ArrowClockwise, ArrowLeftRight } from 'react-bootstrap-icons';
import EditUser from "../components/forms/EditUser";
import EditUserInfo from "../components/forms/EditUserInfo";
import EditBusinessAccount from "../components/forms/EditBusinessAccount";
import Moment from "react-moment";
import Renew from "../components/forms/Renew";
import ChangePlan from "../components/forms/ChangePlan";
import EditUserAvatar from "../components/forms/EditUserAvatar";
import EditAccountLogo from "../components/forms/EditAccountLogo";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var AccountConfig = function AccountConfig() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    businessAccount = _useState6[0],
    setBusinessAccount = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showRenew = _useState8[0],
    setShowRenew = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showChangePlan = _useState0[0],
    setShowChangePlan = _useState0[1];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getuser/' + Common.currentUser.id + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUser(response.data.user);
        setBusinessAccount(response.data.account);
      } else {
        message.error({
          content: response.data.message,
          duration: 3
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenuee',
        duration: 3
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 7,
          children: /*#__PURE__*/_jsx(Tabs, {
            animated: true,
            items: [{
              label: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PersonLinesFill, {
                  size: 22
                }), " Infos personnelles"]
              }),
              key: "p1",
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsxs("div", {
                  className: "cool-radius",
                  style: {
                    background: '#DEB98B'
                  },
                  children: [user != null && /*#__PURE__*/_jsx(Container, {
                    children: /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 4,
                        sm: 3,
                        xs: 3,
                        children: /*#__PURE__*/_jsx(EditUserAvatar, {
                          user: user
                        })
                      }), /*#__PURE__*/_jsxs(Col, {
                        lg: 8,
                        md: 8,
                        sm: 9,
                        xs: 9,
                        children: [/*#__PURE__*/_jsx("h6", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "Info Utilisateur"
                          })
                        }), /*#__PURE__*/_jsx(EditUserInfo, {
                          user: user,
                          handleUpdate: function handleUpdate() {}
                        })]
                      })]
                    })
                  }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                    active: true
                  })]
                })
              })
            }, {
              label: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HospitalFill, {
                  size: 22
                }), " Infos compte"]
              }),
              key: "p2",
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx("div", {
                  className: "white-bg",
                  style: {
                    borderRadius: "8px"
                  },
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 3,
                      xs: 3,
                      children: /*#__PURE__*/_jsx(EditAccountLogo, {
                        user: user
                      })
                    }), /*#__PURE__*/_jsxs(Col, {
                      lg: 8,
                      md: 8,
                      sm: 9,
                      xs: 9,
                      children: [/*#__PURE__*/_jsx("h6", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Infos compte"
                        })
                      }), /*#__PURE__*/_jsx(EditBusinessAccount, {
                        businessAccountId: Common.currentUser.business_account_id,
                        handleUpdate: function handleUpdate() {}
                      })]
                    })]
                  })
                })
              })
            }, {
              label: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PersonFillLock, {
                  size: 22
                }), " Mot de passe"]
              }),
              key: "p3",
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsxs("div", {
                  className: "white-bg",
                  children: [/*#__PURE__*/_jsx("h6", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "Changer le mot de passe du compte"
                    })
                  }), /*#__PURE__*/_jsx(ChangePassword, {
                    user: user
                  })]
                })
              })
            }]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              minHeight: "500px",
              padding: "14px",
              marginTop: "64px",
              background: "#FFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px"
            },
            children: [/*#__PURE__*/_jsx("h6", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Abonnement"
              })
            }), businessAccount && /*#__PURE__*/_jsxs("div", {
              style: {
                padding: "15px",
                borderRadius: "7px",
                border: businessAccount.status == 1 ? "1px dashed #71DE69" : "1px dashed #DE443C"
              },
              children: [businessAccount.subscription_plan && /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: businessAccount.subscription_plan.label
                  })
                }), /*#__PURE__*/_jsxs(Tag, {
                  color: "#405871",
                  children: [businessAccount.subscription_plan.monthly_price.toLocaleString("Fr"), " GNF / Mois"]
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Status "
                  })
                }), businessAccount && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [businessAccount.status == 1 && /*#__PURE__*/_jsx("h5", {
                    style: {
                      width: "12px",
                      height: "12px",
                      borderRadius: "12px",
                      background: "#71DE69"
                    }
                  }), businessAccount.status == 0 && /*#__PURE__*/_jsx("h5", {
                    style: {
                      width: "12px",
                      height: "12px",
                      borderRadius: "12px",
                      background: "#DE443C"
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Date de prochaine facturation"
                }), /*#__PURE__*/_jsx("br", {}), businessAccount.next_due_date && /*#__PURE__*/_jsx(Moment, {
                  date: businessAccount.next_due_date,
                  format: "DD/MM/YYYY"
                })]
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsx(Col, {
                lg: 12,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center"
                  },
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      icon: /*#__PURE__*/_jsx(ArrowClockwise, {}),
                      style: {
                        background: "#DE543C"
                      },
                      onClick: function onClick() {
                        setShowRenew(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Renouveler"
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      icon: /*#__PURE__*/_jsx(ArrowLeftRight, {}),
                      style: {
                        background: "#23805C"
                      },
                      onClick: function onClick() {
                        setShowChangePlan(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Changer de plan"
                      })
                    })]
                  })
                })
              })
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
              children: /*#__PURE__*/_jsx("b", {
                children: "Historique des paiements"
              })
            })]
          })
        })]
      })
    }), businessAccount != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Souscription"
        }),
        open: showRenew,
        onCancel: function onCancel() {
          setShowRenew(false);
        },
        footer: null,
        width: {
          xs: '95%',
          sm: '80%',
          md: '50%',
          lg: '30%',
          xl: '30%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(Renew, {
          businessAccount: businessAccount
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Changez votre formule"
        }),
        open: showChangePlan,
        onCancel: function onCancel() {
          setShowChangePlan(false);
        },
        footer: null,
        width: {
          xs: '95%',
          sm: '80%',
          md: '50%',
          lg: '30%',
          xl: '30%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(ChangePlan, {
          businessAccount: businessAccount
        })
      })]
    })]
  });
};
export default AccountConfig;